import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home/Home';
import Upload from './pages/Upload/Upload';
import Reports from './pages/Tasks/Reports';
import FeatureSelection from './pages/FeatureSelection/FeatureSelection';
import RegulationsUpload from './pages/Upload/RegulationsUpload';
import ProspectusUpload from './pages/Upload/ProspectusUpload';
import CrossCheckUpload from './pages/Upload/CrossCheckUpload';
import StreamViewer from './pages/StreamViewer/StreamViewer';
import RequireAuth from './components/RequireAuth';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/feature-selection"
              element={
                <RequireAuth>
                  <FeatureSelection />
                </RequireAuth>
              }
            />
            <Route
              path="/upload"
              element={
                <RequireAuth>
                  <Upload />
                </RequireAuth>
              }
            />
            <Route
              path="/regulations-check"
              element={
                <RequireAuth>
                  <RegulationsUpload />
                </RequireAuth>
              }
            />
            <Route
              path="/prospectus-check"
              element={
                <RequireAuth>
                  <ProspectusUpload />
                </RequireAuth>
              }
            />
            <Route
              path="/cross-check"
              element={
                <RequireAuth>
                  <CrossCheckUpload />
                </RequireAuth>
              }
            />
            <Route
              path="/reports"
              element={
                <RequireAuth>
                  <Reports />
                </RequireAuth>
              }
            />
            <Route
              path="/stream/:taskUuid"
              element={
                <RequireAuth>
                  <StreamViewer />
                </RequireAuth>
              }
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
